/**
 * "PAID TO DATE" - WHAT THE MONTHLY PAYOUTS ON /payments HAVE PAID, AND ONLY WHEN THAT IS EXACT.
 *
 * The prototype's Payments draws four money cards, one of them "Paid to date" (design 15, the
 * owner's live look at real cabinets, 2026-10-01). The platform serves no such field, and the
 * payments screen invents no figure the platform did not agree to - so this is drawn ONLY where it
 * is a plain count of what the payments view already says, and left out everywhere else:
 *
 *  - THE LIST IS WHOLE. `PaymentsView.payouts` is "One entry per run this author appeared in" and
 *    it is not paged: the server reads every run item of the author with no limit
 *    (src/modules/money/queries/payout-history.reader.ts, `PayoutHistoryReader.read`). Absent, there
 *    is nothing to count, and the card is not drawn.
 *  - ONLY MONEY THAT WAS PAID. `paidAt` is written by the `paid` move alone, and `paid` is a final
 *    status - nothing moves an item out of it (`PAYOUT_ITEM_TRANSITION_RULES`,
 *    src/modules/money/write/payout-run.constants.ts). A payout on its way, disputed, failed or
 *    worked out and not approved has no `paidAt` and is not counted.
 *  - ONE CURRENCY. Each run carries the currency of the rules it was priced by; amounts in two
 *    currencies are not added, and the card is not drawn.
 *  - NOTHING PAID YET IS NOT A CARD. "Paid to date: €0.00" over an author paid for years before
 *    these payouts began would read as a fault, so no paid payout means no card.
 *
 * Earlier payments are not in it, and the card says so. Integer minor units, added and never
 * divided (../../features/cabinet/components/money.tsx, rule 2).
 */
import type { PaymentsView } from '../../features/cabinet/api';

export function paidToDateMinor(payments: PaymentsView): number | undefined {
  const payouts = payments.payouts;
  if (payouts === undefined) {
    return undefined;
  }
  let total = 0;
  let paid = 0;
  for (const payout of payouts) {
    if (payout.paidAt === undefined || payout.paidAt === null) {
      continue;
    }
    if (
      payout.currency !== payments.currency ||
      payout.amountMinor === undefined ||
      payout.amountMinor === null
    ) {
      return undefined;
    }
    total += payout.amountMinor;
    paid += 1;
  }
  return paid === 0 ? undefined : total;
}
